import { Typography } from '@mui/joy';

export default function ToastText({ children }) {
  return (
    <div>
      <Typography>{children}</Typography>
    </div>
  );
}
